// Core
import React from 'react';

// Components
import { EquipmentSensorList } from '../../../../../../components/EquipmentSensorList';
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../../../../../layout/elements/Paragraph';

// Component
import { Container, TitleContainer } from './ListModule.style';
import { ListModuleProps } from './ListModule.types';

function ListModule({
  className,
  items,
  testId,
  title,
}: ListModuleProps): JSX.Element {
  return (
    <Container className={className} data-testid={testId}>
      <TitleContainer>
        <Paragraph size={ParagraphSize.lg} weight={ParagraphWeight.bold}>
          {title}
        </Paragraph>
      </TitleContainer>
      <EquipmentSensorList items={items} />
    </Container>
  );
}

export { ListModule };
